// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  url: "https://k2prod.azurewebsites.net/",
  firmwareUrl: "https://k2dev.azurewebsites.net/",
  // superUserUrl: "http://192.168.1.179:3000/api",
  superUserUrl: "https://88b2t2sf-3000.inc1.devtunnels.ms/api",
  // firmwareUrl: "http://localhost:7071/",
  // url: "http://localhost:3000/",
  // url: "http://192.168.1.179:3000/",
  defaultauth: "azure",
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
